import React from 'react';
import { useTranslation } from 'react-i18next';
import { Typography, Button, Box } from '@utex/ui-kit';
import { Title, Block, CompassWrapper, Compass, Arrow, Wrapper } from './styles';

interface Props {
  advice?: string;
  button?: React.ReactNode;
}

export const NotFound: React.FC<Props> = ({ advice, button }) => {
  const { t } = useTranslation('notFound');

  return (
    <Wrapper>
      <Title>{t('Oops Page not found')}</Title>
      <Block data-testid="not-found-block">
        <CompassWrapper>
          <Compass src="https://investment-s3.unitedtraders.io/not-found/compass.svg" alt="" />
          <Arrow src="https://investment-s3.unitedtraders.io/not-found/arrow.svg" alt="" />
        </CompassWrapper>

        <Box margin={[30, 0, 30]}>
          <Typography.Paragraph size="XL">{t('Error 404')}</Typography.Paragraph>
          <Typography.Paragraph size="M">
            {advice || t('Return or go to the main page')}
          </Typography.Paragraph>
        </Box>

        {button || (
          <Button href="/" data-testid="main-page-btn">
            {t('Open the main page')}
          </Button>
        )}
      </Block>
    </Wrapper>
  );
};
